Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pagePreviewRegister = void 0;
exports.pagePreviewRegister = {
  type: 'REGISTER_MODULE',
  moduleId: 'pagePreview',
  module: {
    heading: 'Page preview admin module',
    options: {},
    order: 1,
    path: '/admin/page-preview'
  }
};